import Scroller from './components/Scroller.js';
import SectionSparkle from './components/SectionSparkle.js';
import Carousel from './components/Carousel.js';
import TextScramble from './components/TextScramble.js';
import TextAnim from './components/TextAnim.js';
import WaveImage from './components/WaveImage.js';
import FloatingShapes from './components/FloatingShapes.js';
import EventDepthGallery from './components/EventDepthGallery.js';
import Konami from './components/Konami.js';

export default class ComponentFactory {
  constructor() {
    this.componentInstances = [];
    this.componentList = {
      SectionSparkle,
      Scroller,
      Carousel,
      TextScramble,
      TextAnim,
      WaveImage,
      FloatingShapes,
      EventDepthGallery,
      Konami,
    };
    this.init();
  }
  init() {
    const components = document.querySelectorAll('[data-component]');

    for (let i = 0; i < components.length; i++) {
      const element = components[i];
      const componentName = element.dataset.component;

      if (this.componentList[componentName]) {
        const instance = new this.componentList[componentName](element);
        this.componentInstances.push(instance);
      } else {
        console.log(`La composante ${componentName} n'existe pas`);
      }
    }
  }
}
